module.exports = __webpack_public_path__ + "media/images/guideline/B01-9a18d88c9d564d59ffb0c2179d185645.jpg";